var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPycharm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 38.78,
    x2: 95.91,
    y1: 41.59,
    y2: 41.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21d789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c3f2"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -29.18,
    x2: 88.46,
    y1: 85.52,
    y2: -1.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcf84a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a7eb62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5fe077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#32da84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#21d789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#21d789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#21d789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#20d68c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1ed497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#19d1a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#13ccc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0bc6e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c3f2"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 17.3,
    x2: 36.92,
    y1: 110.99,
    y2: 49.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21d789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#24d888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2fd985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#41dc80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5ae079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7ae46f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#a1ea64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cff157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcf84a"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 43.28,
    x2: 85.97,
    y1: 57.46,
    y2: 0.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21d789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#23d986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#2ade7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#36e669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3bea62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#47eb61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#67ed5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#9af156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#e0f64d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcf84a"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 108.58,
    x2: 22.55,
    y1: 64.77,
    y2: 63.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fcf84a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ecf74c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c1f451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7eef5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bea62"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m87.54 23.954 34.194 28.44-12.312 25.051-20.614-5.717H70.973z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m53.09 42.423-6.619 35.023-.634 11.898-16.689 7.229-23.662 2.548 7.18-75.666L55.54 5.486l26.417 17.323z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m53.09 42.423 3.218 67.486-10.691 12.605L5.486 99.121l32.951-49.103z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M97.243 37.498H56.698L92.526 5.486z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M122.514 110.178 86.82 122.295 39.289 108.91 53.09 42.423l5.51-4.925 28.94-2.718-2.621 29.062 23.016-8.923z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.429 27.429h73.143v73.143H27.429z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.547 86.747h27.429v4.571H36.547zm.024-50.176h11.215c6.534 0 10.496 3.877 10.496 9.472v.073c0 6.339-4.937 9.63-11.081 9.63h-4.534v8.216h-6.095zm10.801 13.812c3.011 0 4.779-1.792 4.779-4.145v-.073c0-2.706-1.877-4.157-4.876-4.157h-4.608v8.375zm14.178-.024v-.073A13.909 13.909 0 0 1 75.825 36.12a14.129 14.129 0 0 1 10.801 4.218l-3.828 4.425a10.155 10.155 0 0 0-7.01-3.096c-4.62 0-7.948 3.84-7.948 8.533v.085c0 4.693 3.255 8.606 7.948 8.606 3.133 0 5.047-1.219 7.205-3.206l3.828 3.864a13.97 13.97 0 0 1-11.227 4.876 13.836 13.836 0 0 1-14.043-14.068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPycharm);
export default __webpack_public_path__ + "static/media/pycharm.626eae2e829432730c8a5469800fe507.svg";
export { ForwardRef as ReactComponent };